<template>
  <div class="bg">
    <div class="content">
      <div class="news">
        <div class="title">
          <div class="main">
            <div class="title-CN">焦点新闻</div>
            <div class="title-En">Focus News</div>
          </div>
          <div class="sub">More</div>
        </div>
        <div class="main-news">
          <img class="main-news-img" src="../../../assets/sportsLogo/mainNews.png" alt=""/>
        </div>
        <div class="sub-news">
          <img class="sub-news-img" src="../../../assets/sportsLogo/subNews1.png" alt=""/>
          <img class="sub-news-img" src="../../../assets/sportsLogo/subNews2.png" alt=""/>
        </div>
      </div>
      <div class="rank">
        <div class="title">
          <div class="main">
            <div class="title-CN">机构排行榜</div>
            <div class="title-En">Club Rankings</div>
          </div>
          <div class="sub">More</div>
        </div>
        <div class="rank-table">
          <div class="table-header" style="padding:20px 0;font-weight:bold;">
            <div class="table-header-r">排名</div>
            <div class="table-header-a">机构</div>
            <div class="table-header-s">积分</div>
          </div>
          <div class="table-body">
            <div class="table-header" style="height:58.87px;line-height:58.87px;padding:0 0;" v-for="(item,index) in rank.slice(0,7)" :key="index">
              <div class="table-header-r" style="font-size:15px;font-weight:bold;">{{index+1}}</div>
              <div class="table-header-a" style="font-size:15px;font-weight:bold;">
                <img class="agency-img" :src="item.unitlogo" alt="">
                {{item.unitName}}</div>
              <div class="table-header-s" style="font-size:15px;font-weight:bold;">{{item.score}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      info: {},
      rank: []
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.loadData()
  },
  methods: {
    loadData () {
      let param = {
        programId: this.$route.query.programId,
        province: -1,
        year: -1,
        name: -1,
        type: -1,
        pageNum: 1,
        pageSize: 8 // 此处只展示8条数据
      }
      this.$api.match.getAgencyRank(param).then(res => {
        if (res.status === 0) {
          // for (let i = 0; i < 10; i++) {
          //   this.rank = res.data.concat(this.rank)
          // }
          this.rank = res.data
          // console.log('rank', this.rank)
        }
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
  background-color: rgb(244,244, 244);
  display: flex;
  justify-content: center;
}
.content {
  width: 1200px;
  // height: 100px;
  // background-color: grey;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 62px 0 90px 0;
}
.news {
  flex: 4;
  margin-right: 40px;
  // background-color: greenyellow;
}
.rank {
  flex: 3;
  // background-color: hotpink;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
  margin-bottom: 16px;
}
.main {
  width: 60%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.title-CN {
  // flex: 1;
  margin-right: 5px;
  font-weight: bolder;
  font-size: 24px;
}
.title-En {
  // flex: 1;
  font-weight: bolder;
  font-size: 20px;
}
.sub {
  font-weight: normal;
  font-size: 14px;
}
.main-news{
  height: 350px;
  margin-bottom: 10px;
}
.main-news-img {
  width: 100%;
  height: 100%;
}
.sub-news {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 150px;
}
.sub-news-img {
  width: 49%;
  height: 100%;
}
.rank-table{
  width: 100%;
  height: 510px;
  background-color: rgb(255,255,255);
}
.table-body{
  overflow: hidden;
}
.table-header{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dfdfdf;
  color: #333;
  font-weight: bold;
  font-size: 18px;
  padding: 6px 0;
}
.pd{
  padding: 15rpx 0;
}
.table-header-r{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table-header-a{
  flex: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;/*强调文本在一行内显示*/
  overflow: hidden;/*溢出内容为隐藏*/
  text-overflow: ellipsis;/*溢出文本显示省略号*/
}
.table-header-s{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.agency-img{
  width: 34px;
  height: 34px;
  margin-right: 6px;
  border-radius: 50%;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/home/NewsAgencyRanking.vue